enum TranscriptionProvider {
  Azure = "azure",
  Deepgram = "deepgram",
}

function isTranscriptionLanguageMulti(transcriptionLanguage) {
  return (
    transcriptionLanguage === "multi" ||
    transcriptionLanguage === "multi-2" ||
    transcriptionLanguage === "multi-3"
  );
}

function isTranscriptionProviderDeepgram(transcriptionProvider) {
  return transcriptionProvider === TranscriptionProvider.Deepgram;
}

function isTranscriptionProviderAzure(transcriptionProvider) {
  return transcriptionProvider === TranscriptionProvider.Azure;
}

function generateAzureTranscriptionSettingsPayload(
  transcriptionLanguage: string
) {
  return {
    transcriptionProvider: TranscriptionProvider.Azure,
    azureSTTSettings: {
      languages: [transcriptionLanguage],
    },
  };
}

function generateDeepgramSettingsPayload(transcriptionLanguage) {
  return {
    transcriptionProvider: TranscriptionProvider.Deepgram,
    deepgramSettings: {
      transcriptionLanguage: transcriptionLanguage,
      transcriptionModel: "nova-2",
    },
  };
}

function getLanguageLabel(transcriptionLanguage, languages) {
  if (transcriptionLanguage === "multi-3") {
    return "Multilingual";
  }

  return languages[transcriptionLanguage]?.label || "";
}

function getMultiLanguageTranscriptionModel(transcriptionLanguage) {
  if (transcriptionLanguage === "multi-3") {
    return "nova-3";
  }

  return "nova-2";
}

function generateMultiLanguageDeepgramSettingsPayload(transcriptionLanguage) {
  const transcriptionModel = getMultiLanguageTranscriptionModel(
    transcriptionLanguage
  );

  return {
    transcriptionProvider: TranscriptionProvider.Deepgram,
    deepgramSettings: {
      transcriptionLanguage: "multi",
      transcriptionModel,
    },
  };
}

function generateTranscriptionSettingsPayload(
  transcriptionLanguage,
  transcriptionProvider
) {
  if (isTranscriptionProviderAzure(transcriptionProvider)) {
    return generateAzureTranscriptionSettingsPayload(transcriptionLanguage);
  }

  if (
    isTranscriptionProviderDeepgram(transcriptionProvider) &&
    isTranscriptionLanguageMulti(transcriptionLanguage)
  ) {
    return generateMultiLanguageDeepgramSettingsPayload(transcriptionLanguage);
  }

  return generateDeepgramSettingsPayload(transcriptionLanguage);
}

function getAzureTranscriptionLanguage(transcriptionSettings) {
  const { azureSTTSettings } = transcriptionSettings;

  return azureSTTSettings?.languages[0];
}

function isTranscriptionModelNova3(transcriptionModel) {
  return transcriptionModel === "nova-3";
}

function getDeepgramTranscriptionLanguage(transcriptionSettings) {
  const { deepgramSettings } = transcriptionSettings;
  const { transcriptionLanguage, transcriptionModel } = deepgramSettings;

  if (isTranscriptionLanguageMulti(transcriptionLanguage)) {
    if (isTranscriptionModelNova3(transcriptionModel)) {
      return "multi-3";
    }

    return "multi-2";
  }

  return transcriptionLanguage;
}

function getTranscriptionLanguage(transcriptionSettings) {
  const { transcriptionProvider } = transcriptionSettings;

  if (isTranscriptionProviderDeepgram(transcriptionProvider)) {
    return getDeepgramTranscriptionLanguage(transcriptionSettings);
  }

  if (isTranscriptionProviderAzure(transcriptionProvider)) {
    return getAzureTranscriptionLanguage(transcriptionSettings);
  }

  return "";
}

export {
  TranscriptionProvider,
  generateTranscriptionSettingsPayload,
  getTranscriptionLanguage,
  getLanguageLabel,
};
